import { BlockWrapper, ChildrenBlock, defineBlock } from '@smartfire/js-block-engine'
import React from 'react'
import { StatsPerformMatchesProvider } from '../../contexts/StatsPerformMatchesContext'

const ScoreLiveContextWrapper: React.FC = ({
    joinedMatchInitialData,
}: {
    joinedMatchInitialData: any
}) => {
    return (
        <BlockWrapper.Without>
            <StatsPerformMatchesProvider
                joinedMatchInitialData={joinedMatchInitialData ?? undefined}
            >
                <ChildrenBlock key="children" childrenBlockComponent={React.Fragment} />
            </StatsPerformMatchesProvider>
        </BlockWrapper.Without>
    )
}

export default defineBlock({
    Block: ScoreLiveContextWrapper,
})
